import './MobileClubOneLogin.scss'

import { ButtonEmpty } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { selectCompanyTab } from '../../../actions/actions'
import { ReactComponent as AdultRoundBorderSvg } from '../../../icons/adult-round-border.svg'
import { isSsoDisabled } from '../../../selectors/selectors'

export default function MobileClubOneLogin() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const ssoDisabled = useSelector(isSsoDisabled)

  return (
    <div className="mobile-club-one-login">
      <button className="sso-button" disabled={ssoDisabled} onClick={() => !ssoDisabled && window.SSO.open()}>
        <div className="button-content">
          <AdultRoundBorderSvg className="button-icon" />
          <span>{t('signIn.button')}</span>
        </div>
      </button>
      <ButtonEmpty className="sso-title" onClick={handleCompanyCustomerLinkClick}>
        {t('signInWithCompanyId.link')}
      </ButtonEmpty>
    </div>
  )

  function handleCompanyCustomerLinkClick() {
    dispatch(selectCompanyTab())
    history.push('/companyCustomer')
  }
}
